/*Import components to ingust in profile */
import * as service from "./Profile.service";
import * as userService from "../../../Service/User.service";
import * as loginService from "../../../Service/LoginService";
import * as areaTeamBranchService from "../../../Service/AreaBranchTeam.service";
import { mapGetters } from "vuex";
import { toasterColor, toasterModel } from "../../../Models/ToasterModel";
import {
  setLocalStorageItem,
  getLocalStorageItem,
  tokensConstant,
} from "../../../Utility/LocalStorage";

import {
  GetUserId,
  GetUserDetails,
  GetUserRoles,
} from "../../../config/app.config";
import Cropiee from "../ImageUpload/ImageUpload";
/* Profile Controller to impliment the user profile logic */

export default {
  name: "Profile",

  components: {
    Cropiee,
  },

  props: ["httpProgress", "titleflag"],

  data() {
    const user = Object({
      FirstName: "",
      LastName: "",
      Area: null,
      Team: "",
      Office: "",
      CellNo: "",
      UserId: "",
      Role: "",
      Email: "",
      ProfileUrl: "",
    });
    this.form = Object.assign({}, this.user);

    return {
      title: this.titleflag,
      areaTeamBranchList: [],
      teams: [],
      officeList: [],
      valid: false,
      isEdit: false,
      isLoader: false,
      isSubmit: false,
      snackbar: false,
      snackMessage: "",
      isImageEdit: false,
      ImageURL: "",
      counterVisibility: "15",
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
        fnameRules: [
          (v) => !!v || "First Name is required",
          (v) =>
            (v && v.length <= 15) ||
            "First Name must be less than 15 characters",
          (v) => /^[a-zA-Z ]*$/.test(v) || "First Name must be valid",
        ],
        lnameRules: [
          (v) => !!v || "Last Name is required",
          (v) =>
            (v && v.length <= 15) ||
            "Last Name must be less than 15 characters",
          (v) => /^[a-zA-Z ]*$/.test(v) || "Last Name must be valid",
        ],
        area: [(val) => !!val || "Area is required"],
        team: [(val) => (val || "").length > 0 || "Team is required"],
        cellno: [(val) => (val || "").length > 0 || "Cell Number is required"],
        office: [(val) => (val || "").length > 0 || "Office is required"],
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) => this.emailReg.test(v) || "E-mail must be valid",
          (v) =>
            !v ||
            v.indexOf("@lbcusa.net", v.length - "@lbcusa.net".length) !== -1 ||
            v.indexOf(
              "@vofoxsolutions.com",
              v.length - "@vofoxsolutions.com".length
            ) !== -1 ||
            "Domain must be @lbcusa.net OR @vofoxsolutions.com",
        ],
        role: [(val) => (val || "").length > 0 || "Role is required"],
      },
      form: Object.assign({}, user),
      roles: GetUserRoles(),
    };
  },

  async mounted() {
    let context = this;

    this.areaTeamBranchList = this.getAllAreaTeamBranch;

    //let userId = GetUserId();
    //await this.GetAreaTeamOfficeForEmployee();
    // if (this.getAllAreaTeamBranch.length > 0) {
    await this.GetUserProfileDetails();
    // }

    this.$router.app.$on("editProfileTrigger", (UserId) => {
      this.$refs.form.reset();
      this.GetUserProfileDetails(UserId);
    });

    //emitting from the Image upload controller (croppie)
    //When saving the selected image
    this.$router.app.$on("ImageUploadTrigger", (imageUrl) => {
      context.isLoader = true;
      context.form.ProfileUrl = imageUrl;
      this.isImageEdit = false;
    });

    //emitting from the Image upload controller (croppie)
    //When cancelling the croppie
    this.$router.app.$on("CancelImageCroppie", () => {
      this.isImageEdit = false;
    });
  },

  computed: {
    showTeamDropDown() {
      if (this.areaTeamBranchList.length == 1) {
        if (this.areaTeamBranchList[0].listTeams.length == 1) {
          return false;
        }
      }
      return true;
    },
    showOfficeDropDown() {
      if (this.areaTeamBranchList.length == 1) {
        if (this.areaTeamBranchList[0].listTeams.length == 1) {
          if (this.areaTeamBranchList[0].listTeams[0].listOffices.length == 1) {
            return false;
          }
        }
      }
      return true;
    },
    ...mapGetters(["getAllAreaTeamBranch"]),
  },

  methods: {
    async GetUserProfileDetails() {
      let context = this;
      context.isLoader = true;
      let result = await userService.getEmployeeProfileDetails();

      if (result != null) {
        context.user = new Object({
          FirstName: result.FirstName,
          LastName: result.LastName,
          Area: result.Area,
          Team: result.Team,
          Office: result.Office,
          CellNo: result.CellNumber,
          UserId: result.Id,
          Role: "",
          Email: result.Email,
          ProfileUrl: result.ProfileUrl,
        });

        this.setInitialDropdowns(result.Area);
      }
    },

    async GetAreaTeamOfficeForEmployee() {
      let result = await areaTeamBranchService.areaBranchTeamService();
    },

    changeArea(selectedArea) {
      //this.$store.dispatch("changeArea", selectedArea);
      this.teams = selectedArea.listTeams;
      this.form.Team = this.teams[0];

      this.changeTeam(this.form.Team);

      //console.log(this.form);
    },
    changeTeam(selectedTeam) {
      //this.$store.dispatch("changeTeam", selectedTeam);
      this.officeList = selectedTeam.listOffices;
      this.form.Office = this.officeList[0];
    },
    setInitialDropdowns(selectedArea) {
      if (this.areaTeamBranchList.length > 0) {
        let area = this.areaTeamBranchList.filter(
          (x) => x.Area == selectedArea
        );
        this.user.Area = area.length > 0 ? area[0] : this.areaTeamBranchList[0];

        let team = this.user.Area.listTeams.filter(
          (x) => x.Team == this.user.Team
        );
        this.teams = this.user.Area.listTeams;
        this.user.Team =
          team.length > 0 ? team[0] : this.user.Area.listTeams[0];

        let Office = this.user.Team.listOffices.filter(
          (x) => x.Office == this.user.Office
        );
        this.officeList = this.user.Team.listOffices;
        this.user.Office =
          Office.length > 0 ? Office[0] : this.user.Team.listOffices[0];
      }
      this.form = Object.assign({}, this.user);
    },

    resetForm() {
      this.form = Object.assign({}, this.user);
      this.$refs.form.reset();
    },

    async submit() {
      this.isSubmit = true;
      this.isLoader = true;
      let context = this;

      let currentuserDetails = {
        Id: context.form.UserId,
        FirstName: context.form.FirstName,
        LastName: context.form.LastName,
        Area: context.form.Area.Area,
        Team: context.form.Team.Team,
        Office:
          context.form.Office.Office != undefined
            ? context.form.Office.Office
            : context.form.Office,
        CellNumber: context.form.CellNo,
        ProfileUrl: context.form.ProfileUrl,
        Email: context.form.Email,
      };

      if (this.$refs.form.validate()) {
        let result = await userService.UpdateUserProfile(currentuserDetails);

        if (result.error == false) {
          this.$store.commit("toaster", toasterModel("Successfully Updated"));

          this.$store.commit("setProfileImage", currentuserDetails.ProfileUrl);
        } else {
          this.$store.commit(
            "toaster",
            toasterModel("Update Failed", toasterColor.error)
          );
        }
      }

      this.isSubmit = false;
    },

    //Show Croppie for add/edit image
    ImportCroppie() {
      if (this.title === "EditProfile") {
        this.isImageEdit = true;
      }
    },
  },

  watch: {
    userDetails: function(val) {
      // `this` points to the vm instance
      this.isEdit = true;

      this.user = Object({
        FirstName: val.FirstName,
        LastName: val.LastName,
        Area: parseInt(val.Area),
        Team: val.Team,
        Office: val.Office,
        CellNo: val.CellNo,
        UserId: val.UserId,
        Role: val.Role,
        Email: val.Email,
      });
      this.form = Object.assign({}, this.user);
    },
    getAllAreaTeamBranch: function(val) {
      if (val.length > 0) {
        this.areaTeamBranchList = this.getAllAreaTeamBranch;
        this.GetUserProfileDetails();
      }
    },
  },

  beforeDestroy() {
    this.$router.app.$off("editProfileTrigger");
    this.$router.app.$off("ImageUploadTrigger");
    this.$router.app.$off("CancelImageCroppie");
  },
};
